import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import preflightApiRequest from 'src/api/preflightApiRequest';
import sendPostMessage from 'src/store/app/operation/sendPostMessage';
import { MESSAGE_TYPE } from 'src/store/app/types';
import { Store } from 'src/store/index';
import fetchEmbroideryPalette from 'src/util/embroidery/fetchEmbroideryPalette';

interface QuantizeResponse {
  url: string;
  colors: string[];
}

const findImageUrl = (store: Store, assetId: string): string => {
  const images = store.gallery.images || [];
  const galleryImage = images.find((img: any) => img.sourcePictureId === assetId || img.id === assetId);
  if ((galleryImage as any)?.url) return (galleryImage as any).url;

  const { structure } = store.design;
  if (structure) {
    const match = structure.spreads
      .flatMap((spread) => spread.pages)
      .flatMap((page) => page.groups?.media || [])
      .find((element) => element.type === 'image' && (element as any).imageId === assetId && (element as any).url);
    if (match) return (match as any).url;
  }
  return '';
};

const handleQuantizedAssetRequestOperation = (assetId: string) => async (
  dispatch: ThunkDispatch<Store, undefined, AnyAction>,
  getState: () => Store,
) => {
  try {
    const palette = await fetchEmbroideryPalette();
    const imageUrl = findImageUrl(getState(), assetId);

    const params = new URLSearchParams({ image_url: imageUrl });

    const response = await preflightApiRequest(
      `/image/quantize?${params.toString()}`,
      { palette: palette.allowedColors, num_colors: 6 },
      'data',
      'POST',
    ) as QuantizeResponse;

    sendPostMessage({
      type: MESSAGE_TYPE['design.setQuantizedAsset'],
      data: {
        assetId,
        file: {
          id: assetId,
          quantizedColors: response.colors || palette.allowedColors,
        },
        url: response.url,
        quantizedUrl: response.url,
      },
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[OP-39631] Quantization failed:', error);

    sendPostMessage({
      type: MESSAGE_TYPE['design.setQuantizedAssetError'],
      data: {
        assetId,
        error: String(error),
      },
    });
  }
};

export default handleQuantizedAssetRequestOperation;
